
/**
 * enum for Plugin Sort Statuses
 */

export enum PluginSortStatusEnum  {
    Popular = 0,
    IncludedInPlan = 1,
    ProductNameAZ = 2,
    ProductNameZA = 3
}